import { NgModule } from "@angular/core";
import { FamocoScanLaserFormComponent } from './famoco-scan-laser-form/famoco-scan-laser-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DynamicFamocoScanLaserComponent } from './dynamic-famoco-scan-laser.component';
import { FamocoScanLaserDesignComponent } from './famoco-scan-laser-design/famoco-scan-laser-design.component';

@NgModule({
    declarations: [
        DynamicFamocoScanLaserComponent, 
        FamocoScanLaserFormComponent, 
        FamocoScanLaserDesignComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule
    ],
    exports: [
        FamocoScanLaserFormComponent
    ],
    entryComponents: [
        DynamicFamocoScanLaserComponent
    ]
})
export class FamocoScanLaserModule {}